module.exports = __webpack_public_path__ + "img/stock1.6ad8d43f.png";